import {
  chakra,
  Box,
  Button,
  ButtonProps,
  Input,
  InputProps,
  Link,
  Stack,
  StackProps,
  Text,
} from '@chakra-ui/react'
import { ScoProductCoupon } from '@src/graphql-types'
import { useSearchParams } from 'next/navigation'
import { parseAsString, useQueryState } from 'nuqs'
import React, { useEffect, useState } from 'react'
import { useCookie } from 'react-use'

type CouponFormProps = {
  coupon?: ScoProductCoupon
  couponCode?: string
  showForm?: boolean
  stackProps?: StackProps
  inputProps?: InputProps
  buttonProps?: ButtonProps
}

export const CouponForm = (props: CouponFormProps) => {
  const params = useSearchParams()
  const [showForm, setShowForm] = useState<boolean>(props.showForm || false)
  const [promo, setPromo] = useQueryState('promo', parseAsString)
  const [facCouponCode, setFacCouponCode] = useQueryState('facCouponCode', parseAsString)
  const [fgCouponCode, setFgCouponCode] = useQueryState('fgCouponCode', parseAsString)
  const [couponCode, setCouponCode] = useQueryState(
    'couponCode',
    parseAsString.withDefault(
      props.couponCode ||
        params.get('couponCode') ||
        params.get('facCouponCode') ||
        params.get('promo') ||
        params.get('fgCouponCode')
    )
  )
  const [couponCodeInputValue, setCouponCodeInputValue] = useState(couponCode)
  const [promoCookie, updatePromoCookie, deletePromoCookie] = useCookie('sco_promo')

  useEffect(() => {
    if (couponCode) {
      setShowForm(false)
    }
  }, [couponCode])

  return (
    <Box>
      {showForm ? (
        <form
          onSubmit={async e => {
            e.preventDefault()
            await setCouponCode(couponCodeInputValue)
          }}
        >
          <Stack direction={'row'} {...(props.stackProps || {})}>
            <Input
              autoFocus={!props.showForm}
              minWidth={'16em'}
              placeholder={'PROMO-CODE'}
              textAlign={'center'}
              value={couponCodeInputValue}
              variant={'outline'}
              onChange={e => setCouponCodeInputValue(e.target.value)}
              {...(props.inputProps || {})}
            />
            <Button type={'submit'} variant={'outline'} {...(props.buttonProps || {})}>
              {props.buttonProps?.title || 'Apply'}
            </Button>
          </Stack>
        </form>
      ) : (
        <>
          {couponCode ? (
            <Text
              as={'span'}
              bgColor={'colorPalette.fg/10'}
              borderRadius={'full'}
              display={'inline-block'}
              fontSize={'sm'}
              padding={'0.25em 0.75em'}
            >
              {`Promo: `}
              <chakra.code>{couponCode}</chakra.code>
              {' • '}
              <Link
                variant={'textLink'}
                onClick={() => {
                  deletePromoCookie()
                  if (couponCode) {
                    setCouponCode(null)
                  }
                  if (facCouponCode) {
                    setFacCouponCode(null)
                  }
                  if (fgCouponCode) {
                    setFgCouponCode(null)
                  }
                  if (promo) {
                    setPromo(null)
                  }
                  setCouponCodeInputValue('')
                  setShowForm(true)
                }}
              >
                Remove
              </Link>
            </Text>
          ) : (
            <Link
              fontSize={'xs'}
              href={'#'}
              opacity={0.5}
              variant={'textLink'}
              onClick={() => setShowForm(true)}
            >
              Apply a Promo Code
            </Link>
          )}
        </>
      )}
    </Box>
  )
}
